import React from "react";

/** Caricamento a tutta area (come ComponentLoader di gestionale-gls). */
export default function Loader({ message = "Caricamento...", full = false }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        minHeight: full ? "100vh" : 160,
        color: "var(--pr-text-muted)",
        fontSize: 13,
        fontWeight: 500,
      }}
    >
      <span className="pr-spinner" style={{ width: 28, height: 28, borderWidth: 3 }} />
      {message}
    </div>
  );
}
